import { Scan } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useTranslation } from '@/hooks/useTranslation';

export function ScannerHeroCard() {
  const { t } = useTranslation();

  return (
    <Link
      to="/traceability/scan"
      data-testid="scanner-hero-card"
      className="flex flex-col gap-4 rounded-2xl bg-gradient-to-br from-primary to-primary/80 p-6 text-primary-foreground shadow-sm transition-opacity hover:opacity-90"
    >
      <Scan className="h-10 w-10" aria-hidden />
      <div className="flex flex-col gap-1">
        <h2 className="section-title text-primary-foreground">
          {t('home.dashboard.scannerTitle')}
        </h2>
        <p className="text-sm text-primary-foreground/80">
          {t('home.dashboard.scannerDescription')}
        </p>
      </div>
    </Link>
  );
}
